import React from 'react'
import JobPageContainer from '../../containers/customer_portal/Job';

const CreateJobPage = () => {
  return <JobPageContainer mode="create" />
}

export default CreateJobPage;
